import i18next from 'i18next';

import { errorDialogStore } from '@egr/xbox/egr-gui-dialogs/errorDialog/ErrorDialogStore';
import { toLocaleDateString } from '@egr/xbox/utils/Date';

function getHeaders(headers: Record<string, string>): Record<string, string> {
    if (errorDialogStore.snapshot.debug) {
        return Object.assign(
            {
                'x-debug-log-exception': 'true'
            },
            headers
        );
    }

    return headers;
}

export function getDefaultJsonHeader(): Record<string, string> {
    return getHeaders({
        'Content-Type': 'application/json; charset=utf-8'
    });
}

export function owdsValidUntil(dateString: string, longString: boolean = false): string {
    const date = new Date(dateString);

    if (longString) {
        return i18next.t(
            'This link is valid until {{date}}.',
            {
                date: toLocaleDateString(date, i18next.language),
                interpolation: { escapeValue: false }
            }
        );
    }

    return i18next.t(
        'available until {{date}}',
            {
            date: toLocaleDateString(date, i18next.language),
            interpolation: { escapeValue: false }
        }
    );
}